export default __webpack_public_path__ + "static/media/Google1.1dc938c2.PNG";